export enum ExtraKey {
  DOWNLOAD_ENABLE = 'DOWNLOAD_ENABLE',
  DOWNLOAD_MAX_PERIOD = 'DOWNLOAD_MAX_PERIOD',
  ICIS_ENABLE = 'ICIS_ENABLE',
  ICIS_SHOW_DELAY = 'ICIS_SHOW_DELAY',
  TPL_MAX_NUM = 'TPL_MAX_NUM',
  SEARCH_MAX_ITEM_COUNT = 'SEARCH_MAX_ITEM_COUNT',
  TREND_MAX_FILTER = 'TREND_MAX_FILTER',

  SHARE_TPL_ENABLE = 'SHARE_TPL_ENABLE',
  ONGOING_NIQ = 'ONGOING_NIQ',
  ONGOING_CUSTOMIZED = 'ONGOING_CUSTOMIZED',

  INTERNAL_USER = 'INTERNAL_USER'
}
